import { render } from "./BIBO_REPOSITION_ENDORSER.vue?vue&type=template&id=3801df39"
import script from "./BIBO_REPOSITION_ENDORSER.vue?vue&type=script&lang=ts"
export * from "./BIBO_REPOSITION_ENDORSER.vue?vue&type=script&lang=ts"
script.render = render

export default script